import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import {
  StyledMenuItemTag,
  type I18nModel,
  type MenuItemTagProps,
} from '@bingads-webui-react/menu-item-tag';
import { NewFeatureTagStyles } from './ui-next-jss/new-feature-tag';

export type MenuItemTagContainerProps = Pick<MenuItemTagProps, 'tagContent' | 'i18n'> & {
  classes: {
    menuItemTagContainer: string;
  };
};

export interface NewFeatureTagProps {
  i18n: I18nModel;
  expDate?: number | null;
}

const UnstyledMenuItemTagContainer = ({
  tagContent,
  classes,
  i18n = null,
}: MenuItemTagContainerProps) => (
  <div className={classes.menuItemTagContainer}>
    <StyledMenuItemTag i18n={i18n} tagContent={tagContent} />
  </div>
);

const MenuItemTagContainer = injectSheet(NewFeatureTagStyles)(UnstyledMenuItemTagContainer);

export const NewFeatureTag = ({
  i18n,
  expDate,
}: NewFeatureTagProps) => (<MenuItemTagContainer
  i18n={i18n}
  tagContent={expDate ? {
        text: 'New_Feature_Label_NewUI',
        expDate,
      } : 'New_Feature_Label_NewUI'}
/>);

NewFeatureTag.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  expDate: PropTypes.shape({}),
};

NewFeatureTag.defaultProps = {
  expDate: null,
};
